/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';
import { UpdateAppDto } from '../../models/update-app-dto';

export interface AppControllerUpdate$Params {
  appId: string;
      body: UpdateAppDto
}

export function appControllerUpdate(http: HttpClient, rootUrl: string, params: AppControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('appId', params.appId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appControllerUpdate.PATH = '/app/{appId}';
